// removed by extract-text-webpack-plugin
module.exports = {"App":"_3HBQVYkxMAhMpjuje9UKIb","gameContainer":"_2LyiguZGzuPju7jWM-i3dG","topMenuContainer":"_33Eu3yh_m1FtouZ-JVA55n","shinkableOne":"_1ywb0jcNwUgLLxx4onRkgl","shinkableTwo":"_3VDrz4QW7VRvEiLrkQY3SG","menuButton":"_3wsCBSITTeFRv57RaIb1Az","active":"_18335YyhHL6SSv8uSHWB5Q","elevatorsScoreSettings":"JS_baZGugYHvG3Jomke-2","row":"_2zwpnwo2NMoJu7CcyRJgQh"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/containers/App/App.css
// module id = 132
// module chunks = 0